import { Controller } from "stimulus";

let previousVariantId;
let selectedQuantity;
let causeIsSelected = false;
export default class extends Controller {
  static targets = [
    "modal",
    "chosenCause",
    "causeList",
    "causeSelection",
    "main",
    "customerDonationsWidget",
    "donationOption",
    "customOption",
    "pills",
    "customDisplay",
    "customInput",
    "footerFull",
    "footerCaret",
    "footerToggle",
    "moreButton",
    "amountOverflowMenu"
  ];

  initialize() {
    this.saveCauseMetaData(this.chosenCauseTarget.dataset["metadata"]);
    if (this.causeSelectionTarget.dataset["chosenCause"] == "true") {
      causeIsSelected = true;
      if(this.element.dataset["chosenCauseVariantId"]) previousVariantId = this.element.dataset["chosenCauseVariantId"];
      selectedQuantity = this.causeSelectionTarget.dataset["quantity"];
    }
    this.widgetSource = this.element.dataset["widgetSource"] || "cart";
    this.roundUp = this.element.dataset["roundUp"] == "1";
    this.fixedWholeAmt = this.element.dataset["fixedWholeAmt"] == "1";
    this.variantType = this.element.dataset["variantType"];
    this.customVariantType = this.element.dataset["customVariantType"];
    this.currencyRate = parseFloat(this.element.dataset["currencyRate"]);
    this.productValue = parseFloat(this.element.dataset["productValue"]);
    this.wholeProductValue = parseFloat(this.element.dataset["wholeProductValue"]);
    this.variantIds = [];
    this.centsVariantIds = [];
    if(this.causeListTargets.length > 0) {
      this.causeListTargets.forEach((cause) => {
        this.variantIds.push(cause.dataset["variantId"]);
        this.centsVariantIds.push(cause.dataset["centsVariantId"]);
      });
    } else {
      this.variantIds.push(this.chosenCauseTarget.dataset["variantId"]);
      this.centsVariantIds.push(this.chosenCauseTarget.dataset["centsVariantId"]);
    }
    this.defaultVariantId = this.element.dataset["defaultVariantId"];
    this.hasBundleFunction = this.element.dataset["bundleFunction"] == "1";
    console.log(`Has bundle func - ${this.hasBundleFunction}`);
    console.log(`Curr rate - ${this.currencyRate}`);
  }

  addCustomAmount(e) {
    if(this.customInputTarget.value && parseInt(this.customInputTarget.value) > 0) {
      selectedQuantity = parseInt(this.customInputTarget.value) / (this.customVariantType == "whole" ? this.wholeProductValue : this.productValue);
      this.selectCause(e);
    }
  }

  showCustom(e) {
    // When "Other" lives in the ⋯ menu (overflowing), show the amount input INSIDE the menu
    // (keep the row + menu visible); otherwise reveal it in the body (pill row hidden).
    const inMenu = this.hasAmountOverflowMenuTarget && this.hasCustomOptionTarget &&
      this.amountOverflowMenuTarget.contains(this.customOptionTarget);
    if (inMenu) {
      this.customOptionTarget.classList.add("d-none");
      this.amountOverflowMenuTarget.appendChild(this.customDisplayTarget);
      this.customDisplayTarget.classList.add("vcdf-in-menu");
      this._customInMenu = true;
    } else {
      if (this.hasPillsTarget) this.pillsTarget.classList.add("d-none");
      if (this.hasAmountOverflowMenuTarget) this.amountOverflowMenuTarget.classList.add("d-none");
    }
    this.customDisplayTarget.classList.remove("d-none");
    this.customInputTarget?.focus();
    this.sendCurrentHeight();
  }

  hideCustom() {
    this.customDisplayTarget.classList.add("d-none");
    this._restoreCustomDisplay();
    if (this.hasPillsTarget) this.pillsTarget.classList.remove("d-none");
    // Close the ⋯ menu too — an in-menu "Other" input leaves it open, so dismissing the input must
    // collapse back to the pill bar (matches the theme-ext Escape behaviour).
    if (this.hasAmountOverflowMenuTarget && !this.amountOverflowMenuTarget.classList.contains("d-none")) {
      this.amountOverflowMenuTarget.classList.add("d-none");
      if (this.hasMoreButtonTarget) this.moreButtonTarget.setAttribute("aria-expanded", "false");
    }
    this.layoutOverflow();
    this.sendCurrentHeight();
  }

  // Move the (moved-into-menu) custom input wrapper back to the main row + restore the "Other" pill.
  _restoreCustomDisplay() {
    if (!this._customInMenu) return;
    this.customDisplayTarget.classList.remove("vcdf-in-menu");
    if (this.hasPillsTarget) this.pillsTarget.parentNode.appendChild(this.customDisplayTarget);
    if (this.hasCustomOptionTarget) this.customOptionTarget.classList.remove("d-none");
    this._customInMenu = false;
  }

  // Collapse amount pills that don't fit into a ⋯ menu, always keeping >=1 amount pill
  // visible. Overflow pills (+ the custom pill) are MOVED into the menu panel so there's a
  // single node per amount — donationOptionTargets/paintSelection keep working wherever it lives.
  layoutOverflow() {
    if (!this.hasPillsTarget || !this.hasMoreButtonTarget || !this.hasAmountOverflowMenuTarget) return;
    if (this.pillsTarget.classList.contains("d-none")) return;                // custom input open
    if (!this.amountOverflowMenuTarget.classList.contains("d-none")) return;  // menu open: don't reflow under the user
    // 1. Restore all pills to the row (before the ⋯ button) for a clean measurement.
    Array.from(this.amountOverflowMenuTarget.children).forEach((n) => {
      if (this.hasCustomDisplayTarget && n === this.customDisplayTarget) return; // custom input restored separately
      this.pillsTarget.insertBefore(n, this.moreButtonTarget);
    });
    this.moreButtonTarget.classList.add("d-none");
    this.moreButtonTarget.classList.remove("vcdf-selected");
    this.moreButtonTarget.setAttribute("aria-expanded", "false");
    this.pillsTarget.classList.remove("vcdf-has-overflow");
    this.element.querySelectorAll(".vcdf-pill-grouped").forEach((p) => p.classList.remove("vcdf-pill-grouped"));
    // 2. Measure (.vcdf-pills is flex:1, so clientWidth is the space available for pills).
    const mainRow = this.element.querySelector(".vcdf-main-row");
    if (!mainRow || !mainRow.clientWidth) return;
    const GAP = 4, MAIN_GAP = 8, MORE_W = 40;
    const rowW = mainRow.clientWidth;
    // Reserve room for the charity (logo + wrapping name — the logo lives INSIDE the charity
    // element in the Rails markup); the pills get the rest.
    // Reserve only what the charity (logo + name) intrinsically needs — measured single-line,
    // offscreen — so a SHORT name doesn't strand pills into the ⋯ menu, but never more than 45% of the
    // row so a LONG name still wraps. The logo lives INSIDE the charity element here.
    const nameEl = this.element.querySelector(".vcdf-main-row .cause-organization");
    let nameW = 0;
    if (nameEl) {
      const probe = nameEl.cloneNode(true);
      probe.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap;width:auto;max-width:none;left:-9999px;top:0";
      nameEl.parentNode.appendChild(probe);
      nameW = probe.offsetWidth;
      probe.remove();
    }
    const logoEl = this.element.querySelector(".vcdf-main-row .vcdf-logo");
    const logoW = logoEl ? logoEl.offsetWidth + 8 : 0;
    const chevronW = this.hasModalTarget ? 14 : 0;
    // Reserve the charity's FULL single-line width (logo + name + caret, no fraction cap) so the pills
    // collapse into ⋯ — down to the minimum 1 pill + ⋯ — to keep the name on as few lines as possible.
    // A cap here forced a long name to wrap over many lines while the pills kept most of the row. The
    // keep-loop below still guarantees ≥1 amount pill stays visible.
    const minCharity = nameW ? logoW + nameW + chevronW : Math.round(rowW * 0.45);
    const W = rowW - minCharity - MAIN_GAP;
    const amountPills = this.donationOptionTargets;
    const customPill = this.hasCustomOptionTarget ? this.customOptionTarget : null;
    const all = customPill ? amountPills.concat(customPill) : amountPills.slice();
    let total = 0;
    all.forEach((p, i) => { total += p.offsetWidth + (i > 0 ? GAP : 0); });
    if (total <= W) { this.sendCurrentHeight(); return; }                     // everything fits
    // 3. Overflow: keep >=1 amount pill; move the rest + custom into the menu.
    this.pillsTarget.classList.add("vcdf-has-overflow");
    let used = amountPills[0] ? amountPills[0].offsetWidth : 0;
    let keep = 1;
    for (let i = 1; i < amountPills.length; i++) {
      const next = GAP + amountPills[i].offsetWidth;
      if (used + next + GAP + MORE_W <= W) { used += next; keep = i + 1; }
      else break;
    }
    for (let i = keep; i < amountPills.length; i++) this.amountOverflowMenuTarget.appendChild(amountPills[i]);
    if (customPill) this.amountOverflowMenuTarget.appendChild(customPill);
    // Join the last visible pill to the caret as a split button.
    if (amountPills[keep - 1]) amountPills[keep - 1].classList.add("vcdf-pill-grouped");
    const anyHiddenSelected = this.amountOverflowMenuTarget.querySelector(".vcdf-selected") != null;
    this.moreButtonTarget.classList.toggle("vcdf-selected", anyHiddenSelected);
    this.moreButtonTarget.classList.remove("d-none");
    this.sendCurrentHeight();
  }

  toggleAmountOverflow(e) {
    if (!this.hasAmountOverflowMenuTarget) return;
    const isOpen = !this.amountOverflowMenuTarget.classList.contains("d-none");
    if (isOpen && this._customInMenu) {
      this._restoreCustomDisplay();
      this.customDisplayTarget.classList.add("d-none");
    }
    this.amountOverflowMenuTarget.classList.toggle("d-none", isOpen);
    e.currentTarget.setAttribute("aria-expanded", (!isOpen).toString());
    this.sendCurrentHeight();
  }

  customKeydown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.addCustomAmount(e);
    } else if (e.key === "Escape") {
      this.hideCustom();
    }
  }

  connect() {
  parent.postMessage(JSON.stringify({checkChosenCauseOnLoad: true}), this.element.dataset.location );
    // Send initial height to parent iframe
    this.sendCurrentHeight();
    // Collapse overflowing amount pills into the ⋯ menu; re-run when the iframe resizes.
    this.layoutOverflow();
    if ("ResizeObserver" in window) {
      this._ro = new ResizeObserver(() => this.layoutOverflow());
      this._ro.observe(this.element);
    } else {
      this._onResize = () => this.layoutOverflow();
      window.addEventListener("resize", this._onResize);
    }
  }

  disconnect() {
    if (this._ro) this._ro.disconnect();
    if (this._onResize) window.removeEventListener("resize", this._onResize);
  }

  toggleCauseDropdown(e) {
    if (!this.hasModalTarget) return;
    const isOpen = !this.modalTarget.classList.contains("d-none");
    this.modalTarget.classList.toggle("d-none", isOpen);
    e.currentTarget.setAttribute("aria-expanded", (!isOpen).toString());
    // The dropdown renders in normal flow, so the iframe needs resizing on open/close.
    this.sendCurrentHeight();
  }

  dismiss() {
    if (!this.hasModalTarget) return;
    this.modalTarget.classList.add("d-none");
    this.chosenCauseTarget.setAttribute("aria-expanded", "false");
    this.sendCurrentHeight();
  }

  toggleDisclosure(e) {
    if (!this.hasFooterFullTarget) return;
    const expanded = this.footerFullTarget.classList.toggle("d-none") === false;
    e.currentTarget.setAttribute("aria-expanded", expanded.toString());
    if (this.hasFooterCaretTarget) this.footerCaretTarget.classList.toggle("vcdf-caret-up", expanded);
    this.sendCurrentHeight();
  }

  displayWidget(e) {
    console.log(this.element.dataset);
    let data = { shadowParent: this.element.dataset.shadowParent, widgetSource: this.widgetSource, showCustomerDonationsWidget: (this.element.dataset.result == 'true'), styles: JSON.parse(this.element.dataset.styles) };
    parent.postMessage(JSON.stringify(data), this.element.dataset.location );
    window.addEventListener("message", this.messageHandler.bind(this));
  }

  handleRequestHeight() {
    const loc = this.element.dataset.location;
    const shadowParent = this.element.dataset.shadowParent;
    for (let step = 0; step < 15; step++) {
      setTimeout(function() {
        let scrollH = document.querySelector("body").scrollHeight;
        let message = { shadowParent: shadowParent, customerDonationsHeight: scrollH };
        parent.postMessage(JSON.stringify(message), loc );
      }, step > 0 ? (step * 100) : 100);
    }
  }

  messageHandler(e) {
    try {
      let data = JSON.parse(e.data);
      if(data.requestHeight) { this.handleRequestHeight(); this.layoutOverflow(); }
      if(data.reloadChosenCause) {
        selectedQuantity = data.quantity;
        this.paintSelection(data.quantity, previousVariantId);
        this.layoutOverflow();
      }
      if(data.chosenCauseRemoved) this.resetWidget();
    } catch(e) { }
  }

  resetWidget() {
    this.causeSelectionTargets.forEach(target => {
      target.dataset["chosenCause"] = false;
      target.dataset["quantity"] = "";
      target.dataset["variantId"] = "";
      target.classList.remove("d-none");
    });
    causeIsSelected = false;
    previousVariantId = null;
    selectedQuantity = null;
    if (this.hasCustomInputTarget) this.customInputTarget.value = "";
    this.paintSelection(null);
    this.handleRequestHeight();
  }

  selectCause(e) {
    this._restoreCustomDisplay();
    if (this.hasAmountOverflowMenuTarget && !this.amountOverflowMenuTarget.classList.contains("d-none")) {
      this.amountOverflowMenuTarget.classList.add("d-none");
      if (this.hasMoreButtonTarget) this.moreButtonTarget.setAttribute("aria-expanded", "false");
    }
    let data;
    let variantId;
    const isCustom = e.currentTarget?.dataset["custom"];
    const clickedQuantity = e.currentTarget?.dataset["quantity"];

    if (causeIsSelected && !isCustom && clickedQuantity) {
      // Clicking the already-selected pill is a no-op. Compare numerically — the
      // server-rendered quantity can be a float string ("1.0") while the pill's
      // data-quantity is an integer string ("1").
      if (selectedQuantity && parseFloat(clickedQuantity) == parseFloat(selectedQuantity)) return;
      // A different pill updates the in-cart donation to the new amount.
      selectedQuantity = clickedQuantity;
    }

    if(previousVariantId) {
      variantId = this.variantIds.includes(previousVariantId.toString()) ? this.chosenCauseTarget.dataset["variantId"] : this.chosenCauseTarget.dataset["centsVariantId"];
    } else {
      // For round-ups with custom amounts, use customVariantType instead of variantType
      // because custom amounts should always use the variant type appropriate for whole currency units
      if(this.roundUp && isCustom) {
        variantId = this.chosenCauseTarget.dataset[this.customVariantType == "whole" ? "variantId" : "centsVariantId"];
      } else if(this.variantType) {
        variantId = this.chosenCauseTarget.dataset[this.variantType == "whole" ? "variantId" : "centsVariantId"]
      } else {
        variantId = this.chosenCauseTarget.dataset[(this.roundUp && ((!isCustom) || this.currencyRate.toFixed() != 1)) || (this.currencyRate.toFixed() != 1 && isCustom) ? "centsVariantId" : "variantId"];
      }
    }
    if (causeIsSelected) {
      data = {
        changeCustomerCause: true,
        previousVariantId: previousVariantId,
        variantId: variantId,
        productId: this.mainTarget.dataset["productId"],
        quantity: selectedQuantity,
        amount: this.calculateAmount(variantId, selectedQuantity),
        widgetSource: this.widgetSource,
        defaultVariantId: this.defaultVariantId,
        hasBundleFunction: this.hasBundleFunction
      }
      this.paintSelection(selectedQuantity, variantId, !!isCustom);
    } else {
      if(!selectedQuantity) {
        selectedQuantity = clickedQuantity;
      }
      data = {
        chooseCustomerCause: true,
        variantId: variantId,
        productId: this.mainTarget.dataset["productId"],
        quantity: selectedQuantity,
        amount: this.calculateAmount(variantId, selectedQuantity),
        widgetSource: this.widgetSource,
        defaultVariantId: this.defaultVariantId,
        hasBundleFunction: this.hasBundleFunction
      };
      causeIsSelected = true;
      this.paintSelection(selectedQuantity, variantId, !!isCustom);
      this.trackController.trackEvent(e.currentTarget, "added donation to cart", {...this.causeMetaData, ...{ amount: parseInt(e.currentTarget.dataset["quantity"]) }});
    }
    //Update the previous variant id
    previousVariantId = variantId;
    parent.postMessage(JSON.stringify(data), this.element.dataset.location);
    // Re-measure so a custom pill submitted from the ⋯ menu (now relabelled e.g. "$50.00") is moved
    // back out of the now-closed overflow menu and either surfaced in the row or re-collapsed —
    // mirroring the theme-ext re-render + re-measure.
    this.layoutOverflow();
  }

  // Highlight the pill that matches the in-cart donation (the highlighted pill IS the
  // confirmation in the pill-bar design). Unmatched quantities light up the custom pill
  // with the formatted amount as its label.
  paintSelection(quantity, variantId = null, isCustom = false) {
    // A repaint driven by an external iframe message (reloadChosenCause / chosenCauseRemoved) can
    // arrive while the "Other" input is open inside the ⋯ menu. Restore it to the main row and close
    // the menu first, so we don't strand the moved input or leave the menu dangling open.
    if (this._customInMenu) this._restoreCustomDisplay();
    if (this.hasAmountOverflowMenuTarget && !this.amountOverflowMenuTarget.classList.contains("d-none")) {
      this.amountOverflowMenuTarget.classList.add("d-none");
      if (this.hasMoreButtonTarget) this.moreButtonTarget.setAttribute("aria-expanded", "false");
    }
    if (this.hasCustomDisplayTarget) this.customDisplayTarget.classList.add("d-none");
    if (this.hasPillsTarget) this.pillsTarget.classList.remove("d-none");
    let matched = false;
    this.donationOptionTargets.forEach((pill) => {
      // Numeric compare: quantity may arrive as "1.0" (server float) or 1 (cart int)
      // while the pill's data-quantity is an integer string.
      const isMatch = !isCustom && quantity != null && quantity !== "" && parseFloat(pill.dataset["quantity"]) == parseFloat(quantity);
      pill.classList.toggle("vcdf-selected", !!isMatch);
      pill.setAttribute("aria-pressed", (!!isMatch).toString());
      if (isMatch) matched = true;
    });
    if (this.hasCustomOptionTarget) {
      const customPill = this.customOptionTarget;
      const customSelected = quantity != null && quantity !== "" && !matched;
      customPill.classList.toggle("vcdf-selected", customSelected);
      customPill.setAttribute("aria-pressed", customSelected.toString());
      if (customSelected) {
        const amount = this.calculateAmount(variantId, quantity);
        if (amount && isFinite(amount)) {
          customPill.textContent = new Intl.NumberFormat(this.element.dataset.locale || "en", {
            style: "currency",
            currency: this.element.dataset.currency || "USD",
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(amount);
        }
      } else if (customPill.dataset["originalLabel"]) {
        customPill.textContent = customPill.dataset["originalLabel"];
      }
    }
    if (this.hasMoreButtonTarget && this.hasAmountOverflowMenuTarget) {
      const hidden = this.amountOverflowMenuTarget.querySelector(".vcdf-selected") != null;
      this.moreButtonTarget.classList.toggle("vcdf-selected", hidden);
    }
  }

  calculateUnitAmount(variantId, quantity) {
    let amount = 0;

    if(this.roundUp && this.centsVariantIds.includes(variantId) && this.productValue == quantity) {
      amount = this.productValue;
    } else {
      amount = this.centsVariantIds.includes(variantId) ? this.productValue : this.wholeProductValue;
    }
    return amount;
  }
  calculateAmount(variantId, quantity) {
    let amount = 0;

    if(this.roundUp && this.centsVariantIds.includes(variantId) && this.productValue == quantity) {
      amount = this.productValue;
    } else {
      const isCentsVariant = this.centsVariantIds.includes(variantId);
      amount = isCentsVariant ? this.productValue : this.wholeProductValue;
      console.log(`${(this.roundUp || this.fixedWholeAmt ? 1 : this.currencyRate)} - ${amount} - ${quantity}`);

      // For automatic round-ups with whole amount variants (quantity = 1), don't multiply by quantity
      // since the quantity is always 1 and the amount is already the full donation.
      // For custom amounts (quantity > 1), we DO multiply by quantity.
      if (!(this.roundUp && !isCentsVariant && quantity == 1)) {
        amount = ((this.roundUp || this.fixedWholeAmt ? 1 : this.currencyRate) * (amount * parseFloat(quantity)));
      }
    }
    console.log(`Calc amount = ${amount}`);
    return amount;
  }

  setSelectedCause(e) {
    if(previousVariantId && e.currentTarget.dataset["variantId"].toString() == previousVariantId.toString()) {
      this.dismiss();
      return;
    }

    this.chosenCauseTarget.dataset["variantId"] =
      e.currentTarget.dataset["variantId"];

      this.chosenCauseTarget.dataset["centsVariantId"] =
      e.currentTarget.dataset["centsVariantId"];

    this.causeListTargets.forEach((cause) => cause.querySelector(".fa-check-circle").classList.add("d-none"));

    let checkBox = e.currentTarget.querySelector(".fa-check-circle")
    checkBox.classList.remove("d-none");
    this.chosenCauseTarget.querySelector(".cause-icon").innerHTML =
      e.currentTarget.querySelector(".cause-icon").innerHTML;
    this.chosenCauseTarget.querySelector(".cause-organization").innerHTML =
      e.currentTarget.querySelector(".cause-organization").innerHTML;

    this.saveCauseMetaData(e.currentTarget.dataset["metadata"]);
    this.updatePpgfVisibility(e.currentTarget.dataset["paypal"] === "true");

    if (causeIsSelected) {
      this.selectCause(e);
    }

    this.dismiss();
    this.layoutOverflow();
  }

  // Show the PayPal Giving Fund footer only for a PayPal-partner cause (mirrors the theme
  // web component, which gates the disclosure on the CURRENT cause's partner type). The
  // markup is always rendered when any cause is PayPal; we toggle its visibility here.
  updatePpgfVisibility(isPaypal) {
    if (!this.hasFooterToggleTarget) return;
    this.footerToggleTarget.classList.toggle("d-none", !isPaypal);
    if (!isPaypal) {
      this.footerToggleTarget.setAttribute("aria-expanded", "false");
      if (this.hasFooterFullTarget) this.footerFullTarget.classList.add("d-none");
      if (this.hasFooterCaretTarget) this.footerCaretTarget.classList.remove("vcdf-caret-up");
    }
    this.sendCurrentHeight();
  }

  saveCauseMetaData(metadata) {
    if(metadata) this.causeMetaData = JSON.parse(metadata);
  }

  get trackController() {
    // const element = document.getElementById("customer_donations_widget") ||
    //               document.getElementById("customer_donations_cart_drawer_widget");

    return this.application.getControllerForElementAndIdentifier(this.element, "track")
  }

  sendCurrentHeight() {
    // Send current widget height to parent iframe for proper sizing
    const currentHeight = document.querySelector("body").scrollHeight;
    parent.postMessage(JSON.stringify({
      shadowParent: this.element.dataset.shadowParent,
      customerDonationsHeight: currentHeight,

    }), this.element.dataset.location);
  }
}
